module.exports = __webpack_public_path__ + "img/50.4eed8aa2.jpg";